import { GrowthBook } from '@growthbook/growthbook-react';

/**
 * Evaluates `featureKey` as it would be for a doctor page (`slug` attribute), without touching the
 * shared instance's attributes: a throwaway instance over the same feature definitions, no tracking
 * callback, so no experiment exposure is reported. For code that must know a slug-targeted flag
 * before (or outside) that doctor's page — the search → profile prefetch and navigation preview.
 */
export function isOnForSlug(growthbook: GrowthBook | undefined | null, featureKey: string, slug: string): boolean {
  if (!growthbook || !slug) return false;
  try {
    return new GrowthBook({ features: growthbook.getFeatures(), attributes: { ...growthbook.getAttributes(), slug } }).isOn(
      featureKey,
    );
  } catch {
    return false;
  }
}
